<template>
  <div>
    <Forms
      ref="frmSinisterWorkshopReturn"
      :title="'IMAGENS'"
      :showHelp="false"
      :showClearButton="false"
      :showSearchButton="false"
    >
      <Alerts ref="alert" />
      <div class="form-group row" v-show="STG_FRUSTRATED || STG_CANCELED">
        <div class="col-md-12 border border-danger rounded bg-danger text-center">
          <span class="text-white" v-if="STG_FRUSTRATED">FRUSTRADO</span>
          <span class="text-white" v-else>CANCELADO</span>
        </div>
      </div>

      <CarInspectionHeader ref="CarInspectionHeader" />

      <div class="form-group row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 text-center">
          <small style="color: #ff0000;">
            Clique na imagem para visualizar ou salvar o arquivo
          </small>
        </div>
      </div>
      <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABWORKSHOP) && regulation">
        <div class="col-md-12 col-sm-12 force-border-bottom pr-4" style="font-size:16px;">
          <div align="right">
            <button
              type="button"
              class="btn btn-third btn-sm"
              @click="addFiles()"
              v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)"
              v-show="!isCompleted"
            >
              <i class="fa fa-cloud-upload"></i><span class="d-md-down-none">&nbsp; Anexar Fotos</span>
            </button>&nbsp;&nbsp;
            <button
              type="button"
              class="btn btn-info btn-sm"
              @click="DownloadByImageType()"
              v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)"
              v-show="false"
            >
              <i class="fa fa-download"></i><span class="d-md-down-none">&nbsp; Download &nbsp;</span>
            </button>&nbsp;
          </div>
        </div>
      </div>
      <b-card no-body>
        <input id="inputImages" type="file" ref="files" multiple style="display: none;" v-on:change="onUploadNew()" >
        <b-tabs card pills fill content-class="mt-3" align="center" style="min-height: 400px" ref="tabs">
          <b-tab title="Vistoria Inicial" active @click="setTabName('VISTORIA_INICIAL')">
            <template slot="title">
              <i class="fa fa-car" aria-hidden="true"></i><span class="pl-1">Vistoria Inicial</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Desmontagens" @click="setTabName('DESMONTAGENS')">
            <template slot="title">
              <i class="fa fa-bolt" aria-hidden="true"></i><span class="pl-1">Desmontagens</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Funilaria" @click="setTabName('FUNILARIA')">
            <template slot="title">
              <i class="fa fa-adjust" aria-hidden="true"></i><span class="pl-1">Funilaria</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Pintura" @click="setTabName('PINTURA')">
            <template slot="title">
              <i class="fa fa-paint-brush" aria-hidden="true"></i><span class="pl-1">Pintura</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Pronto/Finalizado" @click="setTabName('PRONTO')">
            <template slot="title">
              <i class="fa fa-check-square-o" aria-hidden="true"></i><span class="pl-1">Pronto</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Documentos" @click="setTabName('DOCUMENTOS')">
            <template slot="title">
              <i class="fa fa-files-o" aria-hidden="true"></i><span class="pl-1">Documentos</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Outros" @click="setTabName('OUTROS')">
            <template slot="title">
              <i class="fa fa-edit" aria-hidden="true"></i><span class="pl-1">Checklist</span>
            </template>
            <div align="center">
              <div v-if="!images" style="padding-top: 5%;" class="pb-5"><i class="fa fa-image" style="font-size: 70px; color: #e6e6e6; padding-bottom: 5px;" @click="addFiles()"></i><br>Não há nenhuma imagens anexada!</div>
              <b-row v-else>
                <b-col v-for="image in images" :key="image.id" sm="6" md="4" lg="4" xl="3">
                  <a :href="getPath(image.filePath, image.fileName)" target="_black" v-if="image.contentType === 'image/png' || image.contentType === 'image/jpeg' || image.contentType === 'image/jpg' || image.contentType === 'image/gif'">
                    <b-img
                      :title="image.fileName"
                      thumbnail
                      fluid-grow
                      :src="getPath(image.filePath, image.fileName)"
                      alt="Thumbnail"
                      style="background-size: cover; display:inline-block; width: auto; height: auto; max-height: 220px;min-height: 220px;"
                    />
                  </a>
                  <div v-else class="formater-img img-thumbnail img-fluid" style="min-width: 100px; min-height: 220px;">
                    <div style="background-color: #fff; height: 220px; vertical-align: 20%;">
                      <a :href="getPath(image.filePath, image.fileName)" target="_black"  v-b-tooltip.hover :title="'Clique para abrir o arquivo'">
                        <i class="fa fa-file-text-o" style="font-size: 120px; padding-top: 12%;" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <figcaption
                    class="figure-caption text-center pb-2"
                    style="font-size:13px;color: #808080;">
                    {{ image.fileName }} <br>
                    <small class="text-third">{{ image.dateUpdateFormated}}</small>
                  </figcaption>
                  <b-button
                    pill size="sm"
                    variant="danger"
                    @click="onDeleteImage(image.id)"
                    class="mb-4"
                    v-show="hasRole(roles.FUN_DELETEIMAGE)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>&nbsp;
                    {{ $lang.Common.Buttons.Delete }}&nbsp;&nbsp;
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABWORKSHOP) && regulation && this.regulation.stage && this.regulation.stage.mnemonic === 'CONST_REGISTERED'" >
        <div class="col-md-12 col-sm-12 force-border-bottom pr-4" style="font-size:16px;">
          <div align="left">
            &nbsp;&nbsp;<button
              type="button"
              class="btn btn-third btn-sm"
              @click="onRequestQuote()"
              v-if="hasRole(this.roles.RW_REG_TABWORKSHOP)"
              v-show="!isCompleted"
            >
              <i class="fa fa-plus"></i><span class="d-md-down-none">&nbsp; Solicitar Orçamento</span>
            </button>&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </Forms>

    <b-modal ref="modal-confirm-on-request-quote" size="lg" hide-footer title="Solicitar Orçamento">
      <div class="d-block text-center">
        <h3 class="pt-2">
          <i class="fa fa-plus" aria-hidden="true"></i> Todas as fotos foram inseridas na categoria Vistoria Inicial?
        </h3>
        <div>
          <small>Você irá mudará o Estágio da regulação para o próximo (EM ORÇAMENTAÇÃO)</small>
        </div>
      </div>
      <div class="text-center pt-3 pb-4">
        <b-button class="mt-2" variant="danger" @click="onRequestQuoteModalClose">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Não &nbsp;</strong></b-button>&nbsp;
        <b-button class="mt-2" variant="success" @click="onRequestQuoteModalYes">&nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i> <strong>Sim &nbsp;</strong></b-button>
      </div>
    </b-modal>

    <b-modal ref="modal-uploading-image" hide-footer hide-header-close size="xl" :no-close-on-backdrop="true" centered :title="getQntImageSend">
      <b-progress :max="100"  style="height: 20px; border-radius: 5px;" :striped="true" show-progress :animated="true">
        <b-progress-bar :value="qntImagensSend" :variant="variantProgressBar">
          <h7 v-if="qntImagensSend > 0">{{ qntImagensSend }}%</h7>
        </b-progress-bar>
      </b-progress>
    </b-modal>
  </div>
</template>

<script>
import SinisterWorkshopReturn from './sinisterworkshopreturn.js'
export default SinisterWorkshopReturn
</script>

<style>
.formater-img {
  min-width: 400px;
  min-height: 269px;
  max-width: 400px;
  max-height: 269px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/inspection/workshopreturn/SinisterWorkshopReturn.vue